import React, { PropsWithChildren } from 'react'
import { LinkGrid } from '../../../components/linkgrid/LinkGrid'
import { PopularGuideArticlesFragment } from '@gql'

export type PopularGuideArticlesProps = {
  articles: PopularGuideArticlesFragment[]
}

export const PopularGuideArticles: React.FC<PropsWithChildren<PopularGuideArticlesProps>> = ({ articles }) => {
  if(articles == undefined || articles.length === 0){
    return null
  }

  return (
    <React.Fragment>
      <LinkGrid variant="dark">
        {
          articles.length> 0 && articles.map((article, i)  => {
            return (
              <LinkGrid key={i} linkWrapper>
                <LinkGrid link href={article.popularGuidePageLink?.url || '#'} target={article.popularGuidePageLink?.target === '_blank' ? '_blank' : '_self'}>{article.popularGuidePageTitle}</LinkGrid>
              </LinkGrid>)
          })
        }
      </LinkGrid>
    </React.Fragment>
  )
}